import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { StyledItemRow } from "./styles";
import { HubHookFormInput } from "../HubHookFormInput";

const toComma = (n) => Number(n).toLocaleString();
const ItemTableRow = ({ item, idx, hidePrice, hideBoxes }) => {
  const prefix = `items.${idx}`;

  return (
    <>
      <StyledItemRow key={idx}>
        <Typography variant="caption">{toComma(item?.quantity)}</Typography>
        <Stack direction="row" gap="5px">
          <Typography variant="caption">
            {item?.part?.partName} - Line {item?.customerLine}
          </Typography>
          {!hidePrice && (
            <Typography variant="caption" color="hubColors.redMain">
              @ $ {item?.price} ea
            </Typography>
          )}
        </Stack>
        <Typography variant="caption">{item?.part?.partNumber}</Typography>
        <HubHookFormInput name={`${prefix}.label`} placeholder="Label" />
      </StyledItemRow>
      {!hideBoxes && (
        <StyledItemRow key={`${idx}-boxes`}>
          <Typography variant="caption" />
          <Box sx={{ gridColumn: "span 3" }}>
            <HubHookFormInput
              name={`${prefix}.description`}
              placeholder="Description"
              shouldUnregister={false}
            />
          </Box>
        </StyledItemRow>
      )}
    </>
  );
};

export default ItemTableRow;
